exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal-cont{width:95%;margin:0 auto;margin-top:20px}.m-b{margin-bottom:25%}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/module/special-components/Modal-templates/CustomizeTableLayout-modal.vue"],"names":[],"mappings":"AACA,YACI,UAAW,AACX,cAAe,AACf,eAAiB,CACpB,AACD,KACI,iBAAmB,CACtB","file":"CustomizeTableLayout-modal.vue","sourcesContent":["\n.modal-cont {\n    width: 95%;\n    margin: 0 auto;\n    margin-top: 20px;\n}\n.m-b {\n    margin-bottom: 25%;\n}\n"],"sourceRoot":""}]);

// exports
